const ACTIVE_BLOCKCHAIN_KEY = 'dashboard-active-blockchain'
const RANGE_FILTER_KEY = 'dashboard-range-filter'

const setToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export default {
  SET_ACTIVE_BLOCKCHAIN(state, payload) {
    state.activeBlockchain = payload
    setToLocalStorage(ACTIVE_BLOCKCHAIN_KEY, payload)
  },

  SET_RANGE_FILTER(state, payload) {
    state.rangeFilter = payload
    setToLocalStorage(RANGE_FILTER_KEY, payload)
  },
}